import React from "react";

const map = {
  immo:            { label: "Immobilier",        className: "bg-cyan-50 text-cyan-700 ring-cyan-700/10" },
  achat:           { label: "Achat immobilier",   className: "bg-cyan-50 text-cyan-700 ring-cyan-700/10" },
  vente:           { label: "Vente immobilière",  className: "bg-cyan-50 text-cyan-700 ring-cyan-700/10" },
  pacs:            { label: "Pacs",               className: "bg-gray-50 text-gray-700 ring-gray-700/10" },
  mariage:         { label: "Mariage",            className: "bg-violet-50 text-violet-700 ring-violet-700/10" },
  pma:             { label: "PMA",                className: "bg-blue-50 text-blue-700 ring-blue-700/10" },
  certification:   { label: "Certification",      className: "bg-teal-50 text-teal-700 ring-teal-700/10" },
  donation:        { label: "Donation",           className: "bg-green-50 text-green-700 ring-green-700/10" },
  divorce:         { label: "Divorce",            className: "bg-rose-50 text-rose-700 ring-rose-700/10" },
  bail:            { label: "Bail locatif",       className: "bg-emerald-50 text-emerald-700 ring-emerald-700/10" },
  succession:      { label: "Succession",         className: "bg-amber-50 text-amber-700 ring-amber-700/10" },
  procuration:     { label: "Procuration",        className: "bg-sky-50 text-sky-700 ring-sky-700/10" },
  adoption:        { label: "Adoption",           className: "bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-700/10" },
  testament:       { label: "Testament",          className: "bg-gray-50 text-gray-700 ring-gray-700/10" },
  "statut-societe":{ label: "Statut de société",  className: "bg-stone-50 text-stone-700 ring-stone-700/10" },
  aucune_demarche: { label: "Autre démarche",     className: "bg-gray-50 text-gray-700 ring-gray-700/10" },
  autre:           { label: "Autre",              className: "bg-gray-50 text-gray-700 ring-gray-700/10" },
};

function TypeAffaireBadge({ type }) {
  const entry = map[type];
  if (!entry) return null;

  return (
    <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-bold ring-1 ring-inset ${entry.className}`}>
      {entry.label}
    </span>
  );
}

export default TypeAffaireBadge;
